import { Typography } from "@mui/material";
import { useContext, useRef } from "react";
import useStore from "../../../../Store/Store";
import { CodeTab } from "../CodeTab/CodeTab";
import { TopHandle } from "./Handles";
import { SimSteps } from "./SimSteps";
import { SimulationsContext } from "./SimulationsTab";
import { Path } from "../../Path/Path";
import ExternalLinksButtons from "../CodeTab/ExternalLinksButtons";

export const SimulationsEditPanel: React.FC = () => {
  let { currentUnsavedSimulationObject, isMaxSD, isRunning } =
    useContext(SimulationsContext);

  const {
    isEditingSimulations,
    repoData,
    currentPath,
    selectionStartLine,
    selectionEndLine,
    currentRepo,
  } = useStore((state) => ({
    isEditingSimulations: state.simulationsState.isEditingSimulations,
    repoData: state.repoData,
    currentPath: state.currentPath,
    selectionStartLine: state.selectionStartLine,
    selectionEndLine: state.selectionEndLine,
    currentRepo: state.currentRepo,
  }));

  // useRef instead
  const isDragging = useRef(false);

  // Check if there's linked code to show external buttons
  const hasLinkedCode =
    currentPath &&
    repoData[currentPath] &&
    (repoData[currentPath]?.fileContent || repoData[currentPath]?.parentPath);

  return (
    <>
      <div
        className="SimStepsContainer"
        style={{
          display: isEditingSimulations !== "Description" ? "flex" : "none",
        }}
      >
        {currentUnsavedSimulationObject.simSteps &&
        currentUnsavedSimulationObject.simSteps.length > 0 ? (
          <SimSteps isDragging={isDragging} />
        ) : (
          <div
            className="bigGreyButton"
            style={{
              height: "80%",
              cursor: "default",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              textAlign: "center",
            }}
          >
            {currentUnsavedSimulationObject.isAIGenerated ? (
              <>
                <Typography
                  variant="h6"
                  fontWeight={"thin"}
                  style={{ marginBottom: "10px" }}
                >
                  AI-Generated Usecase
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  This is a usecase converted from AI analysis. Right click on
                  diagram cells to add simulation steps and create an
                  interactive walkthrough.
                </Typography>
              </>
            ) : (
              <Typography variant="h6" fontWeight={"thin"}>
                Right click on a diagram cell and select 'Add As Simulation
                Step'
              </Typography>
            )}
          </div>
        )}
      </div>

      <TopHandle isDragging={isDragging} isMaxSD={isMaxSD} />
      <div
        className="wikiAndCodeContainer"
        style={{
          display:
            isEditingSimulations === "SimSteps" || isRunning ? "flex" : "none",
        }}
      >
        {/* Step Description section removed - now using floating window */}
        <div
          data-testid="simulation-source-code-viewer"
          className="simulationCodeContainer"
          style={{ width: "100%", height: "100%", position: "relative" }}
        >
          <Typography variant="subtitle1" color="primary" className="boxTitle">
            Source Code
          </Typography>
          <div className="codeDiv" style={{ paddingTop: "5px" }}>
            <div
              className={`${
                isMaxSD ? "" : "codeContainer"
              } simulationCodeInnerContainer`}
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {isRunning && (
                <div
                  style={{
                    padding: "4px 8px",
                    flexShrink: 0,
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      marginTop: "0px",
                      marginBottom: "2px",
                    }}
                  >
                    <Path />
                  </div>
                  {/* External Links Buttons for Simulation */}
                  {hasLinkedCode && (
                    <div
                      style={{
                        position: "absolute",
                        top: "18px",
                        right: "10px",
                        zIndex: 1000,
                      }}
                    >
                      <ExternalLinksButtons
                        filePath={(
                          repoData[currentPath]?.parentPath || currentPath
                        ).replace(`${currentRepo}/`, "")}
                        startLine={
                          selectionStartLine ||
                          parseInt(repoData[currentPath]?.startLine) ||
                          parseInt(repoData[currentPath]?.tempStartLine) ||
                          undefined
                        }
                        endLine={
                          selectionEndLine ||
                          parseInt(repoData[currentPath]?.endLine) ||
                          parseInt(repoData[currentPath]?.tempEndLine) ||
                          undefined
                        }
                        topOffset="30px"
                      />
                    </div>
                  )}
                </div>
              )}
              <div style={{ flex: 1, overflow: "hidden" }}>
                <CodeTab
                  isMaxSD={isMaxSD}
                  className="simulation-code-tab"
                  styleProp={{ height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimulationsEditPanel;
